import React, { useState } from 'react';
import { CheckCircle2, Gift, ExternalLink, MessageCircle, Copy, Check } from 'lucide-react';
import { SUCCESS_CONFIG } from '../config/successConfig';
import { trackSuccessLinkClick } from '../utils/analytics';

export function SuccessScreen() {
  const [copiedCoupon, setCopiedCoupon] = useState(null);

  const { coupons } = SUCCESS_CONFIG;

  const handleCopyCoupon = (couponCode, couponId) => {
    navigator.clipboard.writeText(couponCode);
    setCopiedCoupon(couponId);
    setTimeout(() => setCopiedCoupon(null), 2000);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-2xl w-full">
        {/* Header de Sucesso */}
        <div className="text-center mb-8">
          <CheckCircle2 className="w-16 h-16 text-amber-500 mx-auto mb-4" />
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Obrigado por participar!</h2>
          <p className="text-gray-600">Sua resposta contribui para o desenvolvimento do mercado cervejeiro nacional.</p>
        </div>

        <div className="text-center mb-8">
          <p className="text-gray-600">Como forma de agradecimento, nossos patrocinadores oferecem cupons de desconto na compra de cervejas com e sem álcool, para você provar novas opções e conhecer cervejas de altíssima qualidade. Garanta abaixo seus cupons exclusivos!</p>
        </div>

        {/* Cupons */}
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-4">
            <Gift className="w-5 h-5 text-amber-600" />
            <h3 className="text-xl font-semibold text-gray-800">Seus cupons exclusivos</h3>
          </div>

          <div className="grid gap-4">
            {coupons.map((coupon) => (
              <div
                key={coupon.id}
                className="border-2 border-gray-200 rounded-xl overflow-hidden hover:border-amber-300 transition"
              >
                {coupon.bannerText && (
                  <div className="p-4 bg-gray-50 border-b border-gray-200">
                    <p className="text-gray-700 text-center">{coupon.bannerText}</p>
                  </div>
                )}
                {coupon.image ? (
                  <img
                    src={coupon.image}
                    alt={coupon.brand}
                    className="w-full h-auto"
                  />
                ) : (
                  <div className={`bg-gradient-to-r ${coupon.color} p-4 text-white`}>
                    <h4 className="font-bold text-lg">{coupon.brand}</h4>
                    <p className="text-2xl font-bold mt-1">{coupon.discount}</p>
                    <p className="text-sm opacity-90 mt-1">{coupon.description}</p>
                  </div>
                )}

                <div className="p-4 bg-gray-50">
                  <div className="flex items-center justify-between mb-3">
                    <code className="font-mono font-bold text-lg text-gray-800">
                      {coupon.code}
                    </code>
                    <button
                      onClick={() => handleCopyCoupon(coupon.code, coupon.id)}
                      className="flex items-center gap-1 px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded-lg transition text-sm font-medium"
                    >
                      {copiedCoupon === coupon.id ? (
                        <>
                          <Check className="w-4 h-4" />
                          Copiado!
                        </>
                      ) : (
                        <>
                          <Copy className="w-4 h-4" />
                          Copiar
                        </>
                      )}
                    </button>
                  </div>

                  <a
                    href={coupon.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackSuccessLinkClick('visit_site', coupon.link, coupon.brand)}
                    className="flex items-center justify-center gap-2 w-full py-2 bg-white border-2 border-gray-200 rounded-lg hover:border-amber-400 hover:bg-amber-50 transition font-medium text-gray-700"
                  >
                    <ExternalLink className="w-4 h-4" />
                    Visitar site
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}
